import axios from "axios";
import { API_URL } from '../../config/runtimeConfig';
import { activateClientFailure, activateClientStart, activateClientSuccess, addClientFailure, addClientStart, addClientSuccess, getClientsFailure, getClientsStart, getClientsSuccess, updateClientFailure, updateClientStart, updateClientSuccess } from './ClientActions'


const axiosInstance = axios.create({
    baseURL: API_URL,
});

export const getClients = async(dispatch, pageSize, page, type, username, idWilaya, idCommune, nom, prenom, email, entreprise)=>{
    let clientFilter = {username:username, type, wilaya: idWilaya, commune: idCommune, nom: nom, prenom: prenom, email: email, entreprise:entreprise};
    dispatch(getClientsStart());
    try{
        const res = await axiosInstance.post(`/admin/clients?pageSize=${pageSize}&page=${page}`,clientFilter,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getClientsSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(getClientsFailure(err.response.data.message))
        }else{
            dispatch(getClientsFailure("Unkown Error"))
        }
    }
}

export const addClient = async(dispatch, type, entreprise, username, password, idWilaya, idCommune, nom, prenom, email, tel1, tel2, carteNumero)=>{
    let client = {type, entreprise, username, password, wilaya:idWilaya, commune:idCommune, nom, email, tel1, tel2, carteNumero};
    dispatch(addClientStart())
    try{
        const res = await axiosInstance.post(`/admin/clients/add`,client,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(addClientSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(addClientFailure(err.response.data.message))
        }else{
            dispatch(addClientFailure("Unkown Error"))
        }
    }
}

export const updateClient = async(dispatch,id, type, entreprise, username, password, idWilaya, idCommune, nom, prenom, email, tel1, tel2, carteNumero)=>{
    let client = {type, entreprise, username, password, wilaya:idWilaya, commune:idCommune, nom, prenom, email, tel1, tel2, carteNumero};
    dispatch(updateClientStart())
    try{
        const res = await axiosInstance.put(`/admin/clients/update/${id}`,client,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(updateClientSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(updateClientFailure(err.response.data.message))
        }else{
            dispatch(updateClientFailure("Unkown Error"))
        }
    }
}

export const ToggleActiveClient = async(dispatch,clientId)=>{
    dispatch(activateClientStart())
    try{
        const res = await axiosInstance.post(`/admin/clients/active`,{id: clientId},{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(activateClientSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(activateClientFailure(err.response.data.message))
        }else{
            dispatch(activateClientFailure("Unkown Error"))
        }
    }
}

